import Grid from '@mui/material/Unstable_Grid2/Grid2'
import AvatarOne from '../../../../Components/AvatarOne/AvatarOne'
import { Typography } from '@mui/material'
import { Cancel } from '@mui/icons-material'
import { VisitantesContext } from '../../../../Providers/VisitantesContext/VisitantesContext'
import { useContext } from 'react'
// import fot from "../../../../../../web/images"

const PessoaSelecionada = ({ pessoa }) => {
    const { removeMoradorSelecionado } = useContext(VisitantesContext)
    return (
        <Grid sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '130px',
            height: '130px',
            // border: '1px solid red',
            margin: '5px',
            borderRadius: '5px',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '5px',
            position: 'relative'
        }}>
            <Grid sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center'
            }}>
                <AvatarOne
                    height={'60px'}
                    width={'60px'}
                    src={`${window.location.origin.replace(':3003', '')}/wsOnePortaria/web/images/${pessoa.IMAGEMPERFIL}`}
                />
                <div style={{ position: 'absolute', top: 0, right: 17 }}>
                    <Cancel title={"Remover morador"} onClick={() => removeMoradorSelecionado(pessoa.CD_ACESSO)} cursor="pointer" color="error" />
                </div>
            </Grid>
            <Typography title={pessoa.nome} sx={{ ...TypographySx, fontWeight: '500' }}>
                {pessoa.nome}
            </Typography>
            <Typography title={`${pessoa.unidade1} - ${pessoa.unidade2}`} sx={{ ...TypographySx, fontSize: '10px' }}>
                {pessoa.unidade1} - {pessoa.unidade2}
            </Typography>
        </Grid>
    )
}

export default PessoaSelecionada

const TypographySx = {
    color: 'black',
    fontSize: '11px',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    width: '100%',
    textAlign: 'center',
    paddingLeft: '5px',
    paddingRight: '5px',
    boxSizing: 'border-box'
}
